import React, {ReactNode} from 'react';
import {TextWeekDayType} from './components/WeekDays/WeekDays.types';

enum HOVER_TYPE_ENUM {
	CIRCLE = 'circle',
	COLOR = 'color',
}

interface PinData {
	date: Date;
	value?: string;
}

interface DatePickerProps {
	visible: boolean;
	showPrevMonthDay?: boolean;
	showNextMonthDay?: boolean;
	showNextMonth?: boolean;
	hoverType?: HOVER_TYPE_ENUM;
	includeDateIntervals?: {
		start: Date;
		end: Date;
	};
	lang?: string;
	disabledButtonPrevMonth?: boolean;
	disabledButtonNextMonth?: boolean;
	pinDayData?: PinData[];
	iconPinDay?: ReactNode;
	selectIconPinDay?: ReactNode;
	colorPinDay?: string;
	captionCalendar?: ReactNode;
	typeTextWeekDay?: TextWeekDayType;
	enableSecondDaySelection?: boolean;
	showBackgroundIntervalWhenHover?: boolean;
	firstDaySelected?: Date;
	secondDaySelected?: Date;
	initialCalendarDate?: Date;
	footerContent?: ReactNode;
	availableDates?: string[];
	isSingleSelection?: boolean;
	onSelectFirstDay: (newDate: Date | undefined) => void;
	onSelectSecondDay?: (newDate: Date | undefined) => void;
	onCloseDatePicker: () => void;
	handleChangeDate: (firstDateSelect: Date, secondDateSelect: Date | null) => void;
	handleChangeDateMobile?: (firstDateSelect: Date, secondDateSelect: Date | null) => void;
}

interface DatePickerStyleProps {
	showNextMonth?: boolean;
}

enum COMPARISON_OPERATOR_ENUM {
	LESS_THAN = 'lessThan',
	GREATER_THAN = 'greaterThan',
	LESS_THAN_OR_EQUAL = 'lessThanOrEqual',
	MORE_THAN_OR_EQUAL = 'moreThanOrEqual',
	EQUAL = 'equal',
}

interface CompareDateWithCurrentProps {
	year: number;
	month: number;
	day: number;
	comparisonOperator: COMPARISON_OPERATOR_ENUM;
}

interface DatePickerLayoutProps {
	visible: boolean;
	showNextMonth?: boolean;
	isMobileWidthDimension: boolean;
	monthState: number;
	yearState: number;
	disabledButtonPrevMonth?: boolean;
	disabledButtonNextMonth?: boolean;
	lang?: string;
	monthFirstCalendar: number;
	yearFirstCalendar: number;
	monthSecondCalendar: number;
	yearSecondCalendar: number;
	typeTextWeekDay?: TextWeekDayType;
	captionCalendar: ReactNode;
	footerContent?: ReactNode;
	firstDaySelected?: Date;
	secondDaySelected?: Date;
	showLabelSelectedDates?: boolean;

	onCloseDatePicker: () => void;
	handlePrevMonth: () => void;
	handleNextMonth: () => void;
	renderCalendarCurrentMonth: (year: number, month: number) => React.JSX.Element[];
	renderCalendarNextMonth: (year: number, month: number) => React.JSX.Element[];
}

interface DatePickerContainerStyleProps {
	visible: boolean;
}

export {HOVER_TYPE_ENUM, COMPARISON_OPERATOR_ENUM};
export type {
	PinData,
	DatePickerProps,
	DatePickerStyleProps,
	CompareDateWithCurrentProps,
	DatePickerLayoutProps,
	DatePickerContainerStyleProps,
};
